import { ConfigProvider, Layout, Menu } from 'antd';
import './Styles/App.css';
import { Content, Footer } from 'antd/lib/layout/layout';
import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from 'react';
import TopHeader from './Components/Layout/TopHeader/TopHeader';
import SideNav from './Components/Sidenav/SideNav';
import NavigationRoutes from './NavigationRoutes';
import { getCurrentLanguage } from './Helpers/RouteHelper';
import { CookieConcent } from './Components/Cookie/CookieConcent';
import ContactForm from './Components/ContactForm/ContactForm';
import { AuthContextProvider, useAuth } from './Contexts/AuthContext';
import { ChromeProvider, useChrome } from './Contexts/ChromeContext';
import { TextService } from './Services/TextService';

<script src="https://accounts.google.com/gsi/client?sensor=false"></script>

const AppContent = () => {
  const { isLoggedIn } = useAuth();
  const { hideChrome } = useChrome();
  const GetText = TextService.GetText;
  const location = useLocation();

  // index.html ships lang="en"; keep it in sync with the route so screen readers pronounce Swedish pages correctly (WCAG 3.1.1)
  useEffect(() => {
    document.documentElement.lang = getCurrentLanguage() === 'se' ? 'sv' : 'en';
  }, [location.pathname]);

  // Chrome visibility is set by the mounted page itself (see Contexts/ChromeContext.tsx's <NoChrome>,
  // used in NavigationRoutes.tsx) rather than re-parsed from the URL here - a URL-pattern guess is
  // exactly what kept drifting out of sync with the actual routing (case, segment count, declaration
  // order all matter there but not here).
  const showHeaderFooter = () => !hideChrome;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {showHeaderFooter() ? <TopHeader /> : ""}
      <Layout>
        <Layout
          style={{

          }}
        >
          <Content
            className={showHeaderFooter() ? "site-layout-background-grey" : "site-layout-background-white"}>
            <SideNav />
            <NavigationRoutes />
            <CookieConcent />
            {!isLoggedIn && <ContactForm />}
          </Content>
        </Layout>
      </Layout>
      {showHeaderFooter() ?
        <Footer className='footer' style={{ textAlign: 'center' }}>OneFront360 © 2024<br></br>
          <div>
            <a href={"/" + getCurrentLanguage() + "/terms"}>Terms of Service</a> |  <a href={"/" + getCurrentLanguage() + "/privacy-policy"}>Privacy Policy</a> | <a href={"/" + getCurrentLanguage() + "/contact"}>Contact</a> | <a href={"/" + getCurrentLanguage() + "/gdpr"}>GDPR</a>
          </div>
        </Footer> : <Footer className='footer' style={{ textAlign: 'center' }}>{GetText("PublicSiteFooter_ProvidedBy")} <a target="_blank" href="/"><u>OneFront 360</u></a> © 2023<br></br>
        </Footer>}
    </Layout>
  );
};

const App = () => {
  return <div className="App">
    <ConfigProvider
      theme={{
        token: {
          colorBgContainer: "white",
          colorPrimary: "#234E70",
        },
        hashed: false
      }
      }
    >
      <BrowserRouter>
        <ChromeProvider>
          <AuthContextProvider>
            <AppContent />
          </AuthContextProvider>
        </ChromeProvider>
      </BrowserRouter>
    </ConfigProvider>
  </div >
};

export default App;